import React, { useState, useEffect } from "react";
import "./ConsentForm.css";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import RadioInput from "../radioInput/RadioInput";
import CheckboxInput from "../checkboxInput/CheckboxInput";
import Select from "../select/Select";
import MultiSelect from "../../components/multiselect/MultiSelect";

const ConsentForm = ({
  allAnswers,
  allQuestions,
  handleChecked,
  handleAnswer,
  handleAnswerHeight,
  handleMultiSelectAnswer,
  consentShowOthers,
  handleOther,
  handleBirthDate,
  birthDate,
  childBirthDate,
  isAdult,
  adultError,
  isInError,
}) => {
  useEffect(() => {
    /* var targetQuestion = allQuestions.sections[3].questions.filter(
      (question) => question.question_type === "dateOfBirth"
    )[0];
    handleBirthDate(
      targetQuestion.question_id,
      userCompanyData.birthday ? userCompanyData.birthday : "",
      allQuestions.sections[3].questions,
      2
    ); */
    /* var targetQuestion = allQuestions.sections[3].questions.filter((question) => question.question_type === "date")[0];
    handleAnswer(targetQuestion.question_id, moment().format("l"), allQuestions.sections[3].questions); */
    var targetFullName = allQuestions.sections[3].questions.filter((question) => question.question_type === "name")[0];
    var fullNameData = JSON.parse(localStorage.getItem("userData"));
    let fullName = fullNameData.first_name + " " + fullNameData.last_name;
    handleAnswer(targetFullName.question_id, fullName, allQuestions.sections[3].questions);
    /* var targetWeight = allQuestions.sections[3].questions.filter((question) => question.question_type === "weight")[0];
    handleAnswer(targetWeight.question_id, 120, allQuestions.sections[3].questions); */
    /* handleAnswerHeight([76, allQuestions.sections[3].questions, 0], "5");
    handleAnswerHeight([76, allQuestions.sections[3].questions, 1], "5"); */
  }, []);

  const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : "";

  const [
    isOpenCalendar,
    //setOpenCalendar
  ] = useState(false);
  // const openCalendar = (isOpen) => {
  //   setOpenCalendar(!isOpen);
  // };

  const testSignature = (question, opt, questions) => {
    let reg = /\d/;
    if (reg.test(opt)) {
      handleAnswer(question, "", questions);
    } else {
      handleAnswer(question, opt, questions);
    }
  };

  const [useOthers, setUseOthers] = useState(false);
  useEffect(() => {
    if (
      (allAnswers[17] != undefined && allAnswers[17] !== "None of the Above") ||
      (allAnswers[18] != undefined && allAnswers[18] !== "No") ||
      (allAnswers[19] != undefined && allAnswers[19] !== "No") ||
      (allAnswers[20] != undefined && allAnswers[20] !== "No") ||
      (allAnswers[81] != undefined && allAnswers[81] !== "No") ||
      (allAnswers[82] != undefined && allAnswers[82] !== "No") ||
      (allAnswers[83] != undefined && allAnswers[83] !== "No")
    ) {
      setUseOthers(true);
    } else {
      setUseOthers(false);
    }
  }, [allAnswers]);

  return (
    <>
      <div className="formContainer">
        {allQuestions &&
          allQuestions.sections &&
          allQuestions.sections.map(
            (section, key) =>
              key === 3 && (
                <>
                  {section.title && (
                    <>
                      <div key={key} className="formHeader">
                        {section.title}
                      </div>
                      <div className="formLine"></div>
                      <>
                        <div key={key} className="formTitle formConsentTitle">
                          Consent Form
                        </div>
                        <div className="formText">
                          Answering the following questions with YES or NO to help ensure that you have a safe physical
                          activity experience on Virdio.
                        </div>
                      </>
                    </>
                  )}
                  {section.questions.map(
                    (question, q) =>
                      (consentShowOthers == 1 ||
                        useOthers == true ||
                        [21, 22, 23].indexOf(question.question_id) == -1) && (
                        <div
                          key={q}
                          className={
                            isInError &&
                            !allAnswers[question.question_id] &&
                            !question.is_optional &&
                            question.question_type !== "date" &&
                            (question.question_type === "dateOfBirth" ? !userData.birthday : true)
                              ? "formContainerError"
                              : "formContainer"
                          }
                        >
                          {question.question ? (
                            question.question_number == "6" || question.question_number == "7" ? (
                              <div
                                className={
                                  isInError && !allAnswers[question.question_id] && !question.is_optional
                                    ? "formSubtitleError"
                                    : "formSubtitle" + (question.question_number !== "1" ? " formConsentSubtitle" : "")
                                }
                              >
                                {question.question_number + ". " + question.question}
                                {/*useOthers
                                  ? question.question_number + ". " + question.question
                                  : question.question_number == "6"
                                  ? "3. " + question.question
                              : "4. " + question.question*/}
                              </div>
                            ) : consentShowOthers === false && useOthers === false ? (
                              <div
                                className={
                                  isInError && !allAnswers[question.question_id] && !question.is_optional
                                    ? "formSubtitleError"
                                    : "formSubtitle" + (question.question_number !== "1" ? " formConsentSubtitle" : "")
                                }
                              >
                                {question.question_number === "13"
                                  ? "" + question.question
                                  : question.question_number + ". " + question.question}
                              </div>
                            ) : (
                              <>
                                {question.question_number === "8" && <div className="formLineSpecial"></div>}
                                <div
                                  className={
                                    isInError && !allAnswers[question.question_id] && !question.is_optional
                                      ? "formSubtitleError"
                                      : "formSubtitle" +
                                        (question.question_number !== "1" ? " formConsentSubtitle" : "")
                                  }
                                >
                                  {question.question_number === "13" || question.question_number === "8"
                                    ? "" + question.question
                                    : question.question_number + ". " + question.question}
                                </div>
                              </>
                            )
                          ) : question.question_type === "radio" ? (
                            <div className="formLineSpecial"></div>
                          ) : (
                            ""
                          )}
                          {question.answers.map((answer, a) => (
                            <div
                              key={a}
                              className={
                                answer.name ===
                                  "I am completing this questionnaire for my child/dependent as parent/guardian" &&
                                allAnswers[32] &&
                                allAnswers[32] ===
                                  "I am completing this questionnaire for my child/dependent as parent/guardian"
                                  ? "container_checked border_checked"
                                  : ""
                              }
                            >
                              {question.question_type === "radio" ? (
                                <div onClick={() => handleAnswer(question.question_id, answer.name, section.questions)}>
                                  <RadioInput
                                    isChecked={
                                      allAnswers &&
                                      allAnswers[question.question_id] &&
                                      allAnswers[question.question_id] === answer.name
                                        ? true
                                        : false
                                    }
                                    textValue={answer.name}
                                    otherAnswers={question.answers}
                                    otherParams={[question.question_id, section.questions]}
                                    handleAnswer={handleAnswer}
                                    checkRadio={() => {
                                      return;
                                    }}
                                    isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                                    isChildAnswer={
                                      answer.name ===
                                        "I am completing this questionnaire for my child/dependent as parent/guardian" &&
                                      allAnswers[32] &&
                                      allAnswers[32] ===
                                        "I am completing this questionnaire for my child/dependent as parent/guardian"
                                        ? true
                                        : false
                                    }
                                  />
                                  {answer.name ===
                                    "I am completing this questionnaire for my child/dependent as parent/guardian" &&
                                    allAnswers[32] &&
                                    allAnswers[32] ===
                                      "I am completing this questionnaire for my child/dependent as parent/guardian" && (
                                      <div className="child_infos">
                                        <div className="formSecondSetWrap">
                                          <div className="formDataTitle">Child or Dependent Name</div>
                                          <input
                                            type="text"
                                            value={allAnswers && allAnswers[72] ? allAnswers[72] : ""}
                                            className={
                                              "formDataInp" +
                                              (isInError && !allAnswers[72] && !question.is_optional
                                                ? " formBirthInvalid"
                                                : "")
                                            }
                                            onChange={(e) =>
                                              handleAnswer(
                                                72,
                                                /^([^0-9]*)$/.test(e.target.value)
                                                  ? e.target.value
                                                  : allAnswers && allAnswers[72]
                                                  ? allAnswers[72]
                                                  : "",
                                                section.questions
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="formSecondSetWrap">
                                          <div className="formDataTitle">Dependent Date of Birth</div>
                                          <input
                                            type="text"
                                            placeholder="MM/DD/YYYY"
                                            value={
                                              allAnswers && allAnswers[73]
                                                ? allAnswers[73]
                                                : childBirthDate
                                                ? childBirthDate
                                                : ""
                                            }
                                            className={
                                              "formDataInp formBirthDate" +
                                              (childBirthDate.length > 0 && !allAnswers[73]
                                                ? " formBirthInvalid"
                                                : "") +
                                              (isInError && !allAnswers[73] && !question.is_optional
                                                ? " formBirthInvalid"
                                                : "")
                                            }
                                            onChange={(e) =>
                                              handleBirthDate(
                                                73,
                                                /^[0-9]*$/.test(e.target.value) ? e.target.value : "",
                                                section.questions,
                                                1
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    )}
                                </div>
                              ) : question.question_type === "checkbox" ? (
                                <CheckboxInput
                                  isChecked={answer.isChecked === true}
                                  textValue={answer.name}
                                  section={key}
                                  question={q}
                                  answer={a}
                                  handleFunction={handleChecked}
                                  handleOther={handleOther}
                                  isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                                />
                              ) : question.question_type === "radioWithCheckbox" ? (
                                a === question.answers.length - 1 ? (
                                  <div
                                    onClick={() => handleAnswer(question.question_id, answer.name, section.questions)}
                                  >
                                    <RadioInput
                                      isChecked={
                                        allAnswers &&
                                        allAnswers[question.question_id] &&
                                        allAnswers[question.question_id] === answer.name
                                          ? true
                                          : false
                                      }
                                      textValue={answer.name}
                                      otherAnswers={question.answers}
                                      otherParams={[question.question_id, section.questions]}
                                      handleAnswer={handleAnswer}
                                      checkRadio={() => {
                                        return;
                                      }}
                                      isInError={
                                        isInError && !allAnswers[question.question_id] && !question.is_optional
                                      }
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <CheckboxInput
                                      isChecked={answer.isChecked}
                                      textValue={answer.name}
                                      section={key}
                                      question={q}
                                      answer={a}
                                      handleFunction={handleChecked}
                                      isInError={
                                        isInError && !allAnswers[question.question_id] && !question.is_optional
                                      }
                                    />
                                  </>
                                )
                              ) : question.question_type === "digitalSignitaure" ? (
                                <div className="formSecondSetSignWrap">
                                  <div
                                    className={
                                      isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    Digital Signature
                                  </div>
                                  <input
                                    type="text"
                                    value={
                                      allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : ""
                                    }
                                    className={
                                      "formDataInp formSignature" +
                                      (isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? " formSignatureErr"
                                        : "")
                                    }
                                    onChange={(e) =>
                                      testSignature(question.question_id, e.target.value, section.questions)
                                    }
                                  />
                                </div>
                              ) : question.question_type === "dateOfBirth" ? (
                                <div>
                                  <div
                                    className={
                                      isInError &&
                                      !allAnswers[question.question_id] &&
                                      !question.is_optional &&
                                      !userData.birthday
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    {answer.name}
                                  </div>
                                  <div className="formDataInp formDate ">
                                    <div className="formCaliText">
                                      {allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : moment(userData.birthday).format("MM/DD/yyyy")
                                        ? moment(userData.birthday).format("MM/DD/yyyy")
                                        : moment(userData.birthdayStr).format("MM/DD/yyyy")
                                        ? moment(userData.birthdayStr).format("MM/DD/yyyy")
                                        : ""}
                                    </div>
                                  </div>
                                  {/* <input
                                    type="text"
                                    placeholder="MM/DD/YYYY"
                                    value={
                                      allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : birthDate
                                        ? birthDate
                                        : moment(userData.birthday).format("MM/DD/yyyy")
                                        ? moment(userData.birthday).format("MM/DD/yyyy")
                                        : ""
                                    }
                                    className={
                                      "formDataInp formBirthDate" +
                                      (birthDate.length > 0 && !allAnswers[question.question_id]
                                        ? " formBirthInvalid"
                                        : "") +
                                      (isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? " formBirthInvalid"
                                        : "")
                                    }
                                    onChange={(e) =>
                                      handleBirthDate(
                                        question.question_id,
                                        /^[0-9]*$/.test(e.target.value) ? e.target.value : "",
                                        section.questions,
                                        2
                                      )
                                    }
                                  /> */}
                                  {!isAdult && adultError && <div className="email_error_msg">{adultError}</div>}
                                </div>
                              ) : question.question_type === "date" ? (
                                <div>
                                  <div className="formDataTitle">{answer.name}</div>
                                  <div className="formDataInp formDate">
                                    {/* {<div
                                      className="formCaliSignifier"
                                      onClick={() => (true ? "" : openCalendar(isOpenCalendar))}
                                    ></div>} */}
                                    <div className="formCaliText">
                                      {allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : moment().format("MM/DD/yyyy")}
                                    </div>
                                    {isOpenCalendar && (
                                      <div className="formCaliHold">
                                        <Calendar
                                          onChange={""}
                                          value={
                                            allAnswers && allAnswers[question.question_id]
                                              ? new Date(allAnswers[question.question_id])
                                              : new Date()
                                          }
                                          formatShortWeekday={(locale, date) =>
                                            ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]
                                          }
                                          calendarType={"US"}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : question.question_type === "name" ? (
                                <div>
                                  <div
                                    className={
                                      isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    {answer.name}
                                  </div>
                                  <input
                                    type="text"
                                    value={
                                      allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : ""
                                    }
                                    className={
                                      "formDataInp formName" +
                                      (isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? " formBirthInvalid"
                                        : "")
                                    }
                                    onChange={(e) =>
                                      handleAnswer(
                                        question.question_id,
                                        /^([^0-9]*)$/.test(e.target.value)
                                          ? e.target.value
                                          : allAnswers && allAnswers[question.question_id]
                                          ? allAnswers[question.question_id]
                                          : "",
                                        section.questions
                                      )
                                    }
                                    disabled={true}
                                  />
                                </div>
                              ) : question.question_type === "height" ? (
                                <div className="formSecondSetSignWrap">
                                  <div
                                    className={
                                      isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    Height
                                  </div>
                                  <div className="form_select_inline_container">
                                    <div className="form_select_inline_holder">
                                      <div className="formDataSelect">
                                        <div className="relative_holder">
                                          <Select
                                            placeholder={"Select"}
                                            selectOptions={[
                                              { value: "2" },
                                              { value: "3" },
                                              { value: "4" },
                                              { value: "5" },
                                              { value: "6" },
                                              { value: "7" },
                                            ]}
                                            selectCallback={handleAnswerHeight}
                                            callBackValue={[question.question_id, section.questions, 0]}
                                            inQuestionare={true}
                                            initVal="5"
                                          />
                                        </div>
                                      </div>
                                      <span>ft</span>
                                    </div>
                                    <div className="form_select_inline_holder">
                                      <div className="formDataSelect">
                                        <div className="relative_holder">
                                          <Select
                                            placeholder={"Select"}
                                            selectOptions={[
                                              { value: "1" },
                                              { value: "2" },
                                              { value: "3" },
                                              { value: "4" },
                                              { value: "5" },
                                              { value: "6" },
                                              { value: "7" },
                                              { value: "8" },
                                              { value: "9" },
                                              { value: "10" },
                                              { value: "11" },
                                            ]}
                                            selectCallback={handleAnswerHeight}
                                            callBackValue={[question.question_id, section.questions, 1]}
                                            inQuestionare={true}
                                            initVal={
                                              allAnswers && allAnswers[47] && allAnswers[47] === "Male" ? "10" : "5"
                                            }
                                          />
                                        </div>
                                      </div>
                                      <span>in</span>
                                    </div>
                                  </div>
                                </div>
                              ) : question.question_type === "weight" ? (
                                <div>
                                  <div
                                    className={
                                      isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    {answer.name}
                                  </div>
                                  <input
                                    type="text"
                                    value={
                                      allAnswers && allAnswers[question.question_id] && allAnswers
                                        ? allAnswers[question.question_id]
                                        : ""
                                    }
                                    maxLength={6}
                                    className={
                                      "formDataInp" +
                                      (isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? " formBirthInvalid"
                                        : "")
                                    }
                                    onChange={(e) =>
                                      handleAnswer(
                                        question.question_id,
                                        /^[0-9,.]*$/.test(e.target.value)
                                          ? e.target.value
                                          : allAnswers && allAnswers[question.question_id]
                                          ? allAnswers[question.question_id]
                                          : "",
                                        section.questions
                                      )
                                    }
                                  />
                                </div>
                              ) : question.question_type === "goals" ? (
                                <div>
                                  <div
                                    className={
                                      isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? "formSubtitleError"
                                        : "formSubtitle"
                                    }
                                  >
                                    {answer.name}
                                  </div>
                                  <div className="multiselect_patient_goals">
                                    <MultiSelect
                                      initVal={[]}
                                      selectOptions={[
                                        { value: "Basketball" },
                                        { value: "Cycling" },
                                        { value: "Golf" },
                                        { value: "Long Walks" },
                                        { value: "Racquet Sports (Tennis, Racquetball, Etc.)" },
                                        { value: "Running" },
                                        { value: "Soccer" },
                                        { value: "Sit, Stand, And Walk Around Pain Free" },
                                        { value: "Swimming" },
                                        { value: "Volleyball" },
                                      ]}
                                      selectCallback={handleMultiSelectAnswer}
                                      callBackValue={[question.question_id, section.questions]}
                                      inQuestionare={true}
                                    />
                                  </div>
                                  {/* <textarea
                                    maxLength={100}
                                    type="text"
                                    placeholder="Tell us more about your goals..."
                                    value={
                                      allAnswers && allAnswers[question.question_id]
                                        ? allAnswers[question.question_id]
                                        : ""
                                    }
                                    className={
                                      "formDataInp form_patient_goals" +
                                      (birthDate.length > 0 && !allAnswers[question.question_id]
                                        ? " formBirthInvalid"
                                        : "") +
                                      (isInError && !allAnswers[question.question_id] && !question.is_optional
                                        ? " formBirthInvalid"
                                        : "")
                                    }
                                    onChange={(e) =>
                                      handleAnswer(question.question_id, e.target.value, section.questions, 2)
                                    }
                                  /> */}
                                </div>
                              ) : question.question_type === "select" ? (
                                <div className="formDataSelect">
                                  <div className="relative_holder">
                                    <Select
                                      placeholder={"Select"}
                                      selectOptions={[
                                        { value: "Female" },
                                        { value: "Male" },
                                        { value: "Prefer not to say" },
                                        { value: "other" },
                                      ]}
                                      selectCallback={handleAnswer}
                                      callBackValue={[question.question_id, section.questions]}
                                      inQuestionare={true}
                                    />
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                        </div>
                      )
                  )}
                </>
              )
          )}
      </div>
    </>
  );
};

export default ConsentForm;
